import { Box, DialogContent, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import Button from '@hapana/shared/web/components/shared/button/button.component'
import { BUTTON_VARIANTS } from '@hapana/shared/web/components/shared/button/button.constants'
import DialogLayout from '@hapana/shared/web/components/shared/dialog/dialog-layout/dialog-layout.component'
import {
  CLOSE_TYPES,
  SIZES,
} from '@hapana/shared/web/components/shared/dialog/dialog-layout/dialog-layout.constants'
import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'
import { useNotifyClientInEquipmentQueue } from '_hooks/equipment-queue.hooks'

import { styles } from './notify-client-dialog.styles'

export const NotifyClientDialog = ({
  clientId,
  clientName,
  equipmentId,
  equipmentName,
  siteId,
}) => {
  const { t } = useTranslation('checkIn')
  const { popDialog } = useDialog()

  const { mutate: notifyClient, isLoading } = useNotifyClientInEquipmentQueue({
    onSuccess: () => {
      popDialog()
    },
  })

  const handleNotify = () => {
    notifyClient({ clientId, siteId, equipmentId })
  }

  return (
    <DialogLayout
      closeType={CLOSE_TYPES.ICON}
      closeAction={popDialog}
      title={t('equipments.waitline.notifyDialog.title')}
      size={SIZES.XS}
    >
      <DialogContent sx={styles.dialogContent}>
        <Typography typography="medium" color="gray.80" sx={styles.description}>
          {t('equipments.waitline.notifyDialog.description', { clientName, equipmentName })}
        </Typography>
        <Box display="flex" justifyContent="flex-end" gap={2}>
          <Button
            variant={BUTTON_VARIANTS.OUTLINED}
            label={t('common:cancel')}
            onClick={popDialog}
          />
          <Button
            variant={BUTTON_VARIANTS.CONTAINED}
            label={t('equipments.waitline.notifyDialog.sendNotification')}
            onClick={handleNotify}
            loading={isLoading}
          />
        </Box>
      </DialogContent>
    </DialogLayout>
  )
}

export default NotifyClientDialog
